import { AxiosError } from 'axios';
import { type MRT_TableOptions, type MRT_RowData } from 'material-react-table';
import { UseQueryResult } from '@tanstack/react-query';
import { Typography } from '@mui/material';

import { CasErrorDisplay, CasTabsView } from 'src/compass/shared/components';
import { formatDate, DateFormat } from 'src/compass/shared/util/casMoment';

import PreliminaryPayoutsTab from './_internal/PreliminaryPayoutsTab';
import PreliminaryAccrualsTab from './_internal/PreliminaryAccrualsTab';

export type CommissionsTabProps = Partial<MRT_TableOptions<MRT_RowData>> & {
  data: any;
  exportUrl?: string;
};

type PreliminaryCommissionsProps = {
  lrpExportUrl?: string;
  cmeExportUrl?: string;
  accrualsExportUrl?: string;
  queryResult: UseQueryResult<any, AxiosError>;
};

export default function PreliminaryCommissions({
  queryResult,
  lrpExportUrl,
  cmeExportUrl,
  accrualsExportUrl,
}: PreliminaryCommissionsProps) {
  const { data, isError, error } = queryResult;

  const {
    employeeName,
    currentPeriodStart,
    overviewRecords,
    lrpRecords,
    cmeRecords,
    accrualRecords,
  } = data || {};

  const tabList = [
    {
      label: 'Payouts',
      children: (
        <PreliminaryPayoutsTab
          {...{ overviewRecords, cmeRecords, lrpRecords, lrpExportUrl, cmeExportUrl }}
        />
      ),
    },
    {
      label: 'Accruals',
      children: <PreliminaryAccrualsTab data={accrualRecords} exportUrl={accrualsExportUrl} />,
    },
  ];

  if (isError) return <CasErrorDisplay message={error.message} />;

  const formattedCurrentPeriodStartDate = formatDate(currentPeriodStart, DateFormat.MMMMY);

  return (
    <>
      <Typography>{`${formattedCurrentPeriodStartDate}: ${employeeName}`}</Typography>
      <CasTabsView tabList={tabList} />
    </>
  );
}
